module.exports = __webpack_public_path__ + "img/team-1.f4d48750.jpg";